import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  private readonly key = 'sj-frontend-secret-key';

  encrypt(value: unknown): string {
    const plain = JSON.stringify(value ?? null);
    return CryptoJS.AES.encrypt(plain, this.key).toString();
  }

  decrypt<T>(cipherText: string | null): T | null {
    if (!cipherText) {
      return null;
    }
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.key);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted ? (JSON.parse(decrypted) as T) : null;
    } catch {
      return null;
    }
  }

  /** Encrypt a plain string field (GST/PAN) for API storage. */
  encryptField(value: string | null | undefined): string | null {
    const plain = value?.trim() ?? '';
    if (!plain) return null;
    return CryptoJS.AES.encrypt(plain, this.key).toString();
  }

  /** Decrypt a plain string field returned from API. */
  decryptField(cipherText: string | null | undefined): string {
    if (!cipherText?.trim()) return '';
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.key);
      return bytes.toString(CryptoJS.enc.Utf8) ?? '';
    } catch {
      return '';
    }
  }
}

